import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { judgeObj, judgeArr, setKey } from '@/shared/functions';
/** @desc 初始默认state */
const initState = {
    coreParam: {},
    type: 'offer',
    visible: false,
    pageIndex: 1,
    pageSize: 20,
    totalNum: 0,
    dataSource: [],
    tableLoading: false,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        // 请求接口
        load(payload, { state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                // 依据type和coreParam去请求不不同的接口
                this.SET_STATE({ tableLoading: true });
                const { pageIndex, pageSize, type, coreParam } = state;
                const _param = Object.assign({ pageIndex,
                    pageSize }, coreParam);
                switch (type) {
                    case 'focus':
                    case 'localFocus':
                        yield this.focusData(_param);
                        break;
                    case 'offer':
                    case 'localOffer':
                        yield this.offerData(_param);
                        break;
                    case 'online':
                    case 'localOnline':
                        yield this.onlineData(_param);
                        break;
                    default:
                        console.warn('membersList load type类型有误');
                }
                this.SET_STATE({ tableLoading: false });
            });
        },
        // 获取关注会员数 & 获取本机构关注会员数
        focusData(payload) {
            return Api.auction.queryFocusPage(payload).then((res) => {
                const data = JSON.parse(JSON.stringify(res));
                if (judgeObj(data) && judgeArr(data.items)) {
                    this.SET_STATE({
                        dataSource: setKey(data.items),
                        totalNum: data.totalNumber,
                    });
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        // 获取出价会员数 & 获取本机构出价会员数
        offerData(payload) {
            return Api.auction.buyerBidRecord(payload).then((res) => {
                const data = JSON.parse(JSON.stringify(res));
                if (judgeObj(data) && judgeArr(data.items)) {
                    this.SET_STATE({
                        dataSource: setKey(data.items),
                        totalNum: data.totalNumber,
                    });
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        // 获取在线会员数 & 获取本机构在线会员数
        onlineData(payload) {
            return Api.suixinhuan.getVipRecord(payload).then((res) => {
                const data = JSON.parse(JSON.stringify(res));
                if (judgeObj(data) && judgeArr(data.buyerBehaviorRecordList)) {
                    this.SET_STATE({
                        dataSource: setKey(data.buyerBehaviorRecordList),
                        totalNum: data.totalCount,
                    });
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        // 展示modal
        show({ coreParam, type }, { state }) {
            this.SET_STATE({
                coreParam,
                type,
                visible: true,
            });
            this.load({});
        },
        // 隐藏modal
        hide() {
            this.SET_STATE({ visible: false });
        },
        // 使用组件方式引用MembersList
        dealUseComponent(payload) {
            this.SET_STATE_USE_COMPONENT(payload);
            // 如果 visibleUseComponent 为true, 请求接口数据
            const { visibleUseComponent } = payload || {};
            if (visibleUseComponent) {
                this.load({});
            }
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        // 设置当前页
        SET_PAGE_CURRENT(state, payload) {
            state.pageIndex = payload;
        },
        // 使用组件方式引用MembersList, 父组件props赋值给state
        SET_STATE_USE_COMPONENT(state, payload) {
            // 如果payload里属性均有定义，则赋值
            const { coreParamUseComponent, typeUseComponent, visibleUseComponent } = payload;
            if (coreParamUseComponent !== undefined && typeUseComponent !== undefined && visibleUseComponent !== undefined) {
                state.coreParam = coreParamUseComponent;
                state.type = typeUseComponent;
                state.visible = visibleUseComponent;
            }
        },
    },
});
